import { ANFAccount } from "../../../api/generated";
import {
  createReportContext,
  type InferReport,
} from "../../../context/ReportContext";

const approvedNotFunded = createReportContext({ rebateAccountIDs: "multi" })<
  { rebateAccountIDs: string },
  {
    table: {
      list: ANFAccount[];
      totalCount: number;
    };
    csv: void;
  },
  {
    startDate: string;
    endDate: string;
    selected: {
      rebateAccountIDs: string[] | null;
    };
    search: string;
    page: number;
    pageSize: number;
    sortColumn: string | null;
    sortDesc: boolean | null;
  }
>();

export const {
  Provider: ClientApprovedNotFundedContextProvider,
  useReportContext: useClientApprovedNotFundedContext,
} = approvedNotFunded;

export type ApprovedNotFundedReportParams = InferReport<
  typeof approvedNotFunded,
  "params"
>;
export type ApprovedNotFundedReportStates = InferReport<
  typeof approvedNotFunded,
  "states"
>;
